// Write your code here
import {Component} from 'react'
import {v4 as uuidv4} from 'uuid'
import AppointmentItem from '../AppointmentItem'
import './index.css'

class Appointments extends Component {
  state = {
    userAppoimentList: [],
    userAppoimentName: '',
    appoimentDate: '',
    importantAppoiment: false,
    showOnlyStartedData: false,
  }

  onChangeUserText = event => {
    this.setState({
      userAppoimentName: event.target.value,
    })
  }

  appDate = event => {
    this.setState({
      appoimentDate: event.target.value,
    })
  }

  changeStatusOfImp = id => {
    this.setState(preSta => ({
      userAppoimentList: preSta.userAppoimentList.map(each => {
        if (id === each.id) {
          return {...each, importantAppoiment: !each.importantAppoiment}
        }
        return each
      }),
    }))
  }

  getDetailsFromForm = event => {
    event.preventDefault()
    const {userAppoimentName, appoimentDate, importantAppoiment} = this.state
    if (userAppoimentName === '') {
      ;<p>h</p>
    } else {
      const newAppoimentDetails = {
        id: uuidv4(),
        userAppoimentName,
        appoimentDate,
        importantAppoiment,
      }
      this.setState(preSta => ({
        userAppoimentList: [...preSta.userAppoimentList, newAppoimentDetails],
        userAppoimentName: '',
        appoimentDate: '',
      }))
    }
  }

  importantData = () => {
    this.setState(preSta => ({
      showOnlyStartedData: !preSta.showOnlyStartedData,
    }))
  }

  dispalyStartedData = () => {
    const {userAppoimentList} = this.state
    const filteredDataList = userAppoimentList.filter(
      eachRev => eachRev.importantAppoiment === true,
    )
    return filteredDataList
  }

  render() {
    const filteredData = this.dispalyStartedData()

    const {
      userAppoimentName,
      appoimentDate,
      userAppoimentList,
      importantAppoiment,
      showOnlyStartedData,
    } = this.state

    const displayData = showOnlyStartedData ? filteredData : userAppoimentList

    const statusOfBtn = showOnlyStartedData
      ? 'btn-stared-filled-sty'
      : 'btn-stared-sty'

    return (
      <div className="bg-container">
        <div className="appoiment-bg-container">
          <h1>Add Appointment</h1>
          <div className="card-formation-con">
            <form onSubmit={this.getDetailsFromForm}>
              <div className="lab-con-1">
                <label htmlFor="lab-1" className="label-sty">
                  Tittle
                </label>
                <input
                  type="text"
                  id="lab-1"
                  value={userAppoimentName}
                  className="input-ele-sty"
                  placeholder="title"
                  onChange={this.onChangeUserText}
                />
              </div>

              <div className="lab-con-1">
                <label htmlFor="date-id" className="label-sty">
                  DATE
                </label>
                <input
                  type="date"
                  id="date-id"
                  value={appoimentDate}
                  className="input-ele-sty"
                  placeholder="title"
                  onChange={this.appDate}
                />
              </div>

              <button className="btn-sty" type="submit">
                Add
              </button>
            </form>
            <img
              src="https://assets.ccbp.in/frontend/react-js/appointments-app/appointments-img.png"
              alt="appointments"
              className="bg-img"
            />
          </div>
          <hr className="hr-sty" />

          <div className="con-2">
            <h1 className="app-container-heading-sty">Appointments</h1>
            <button
              className={statusOfBtn}
              type="button"
              onClick={this.importantData}
              data-testid="star"
            >
              Starred
            </button>
          </div>
          <ul className="ul-sty">
            {displayData.map(eachApp =>
              userAppoimentList.length === 0 ? (
                <p>No Appointments are Avalaible</p>
              ) : (
                <AppointmentItem
                  eachApp={eachApp}
                  changeStatusOfImp={this.changeStatusOfImp}
                  importantAppoiment={importantAppoiment}
                  key={eachApp.id}
                />
              ),
            )}
          </ul>
        </div>
      </div>
    )
  }
}

export default Appointments
